/* global axios */
import ApiClient from '../ApiClient';

class CaptainPreferences extends ApiClient {
  constructor() {
    super('captain/preferences', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }

  updatePreferences(data) {
    return axios.put(this.url, data);
  }

  getAiSettings() {
    return axios.get(`${this.url}/ai_settings`);
  }

  updateAiSettings(data) {
    return axios.patch(`${this.url}/ai_settings`, data);
  }

  getUsage() {
    return axios.get(`${this.url}/usage`);
  }

  validateKey(data) {
    return axios.post(`${this.url}/validate_key`, data);
  }
}

export default new CaptainPreferences();
